<app-data-import type="hazards"></app-data-import>
